import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import TodayIcon from '@material-ui/icons/Today';
import UpdateIcon from '@material-ui/icons/Update';

import InvestorsImg from 'img/imgs/investors.svg';

import CommonDialog from 'components_newui/dialogs/CommonDialog';

import * as pages from 'common_constants/Pages';
import NavigationService from 'support/navigation/NavigationService';

import SingleInputForm from '../../ideaTemplate_list/SingleInputForm';

import {
  formatDate,
  getCardColor,
} from '../utils';

const ScorecardCard = ({
  classes,
  data,
  myEmail,
  getCloneScorecardTemplateFn,
}) => {
  const [openClone, setOpenClone] = useState(false);

  const ROUTES = NavigationService.getRoutes();

  const editPath = ROUTES[pages.UPDATESCORECARDTEMPLATE].pathWithOutID;

  const cardColor = getCardColor(data.id);

  return (
    <>
      <div className={classes.scorecardItem}>
        <div
          className={classes.cardTopBorder}
          style={{
            background: cardColor,
          }}
        />

        <div className={classes.cardHeader}>
          <h3 className={classes.scorecardName}>
            {data.templateName}
          </h3>

          <div className={classes.actionWrap}>
            <button
              type="button"
              className={`${classes.btns} ${classes.cloneBtn}`}
              onClick={() => setOpenClone(true)}
            >
              <FileCopyOutlinedIcon
                fontSize="small"
              />
              Clone
            </button>

            <Link
              className={`${classes.btns} ${classes.editBtn}`}
              style={{
                background: cardColor,
                borderColor: cardColor,
              }}
              to={{
                pathname: `${editPath}/${data.id}`,
                state: data,
              }}
            >
              <EditOutlinedIcon
                fontSize="small"
              />
              Edit
            </Link>
          </div>
        </div>

        <div className={classes.divider} />

        <div className={classes.avtarContent}>
          <div className={classes.imgblock}>
            <img
              src={InvestorsImg}
              alt="avatar"
              className={classes.noimg}
            />
          </div>

          <div className={classes.avtarDetails}>
            <div className={classes.ownerName}>
              {data.createdBy}
            </div>

            <div className={classes.dateRow}>
              <span className={classes.dateText}>
                <TodayIcon fontSize="small" />
                {formatDate(data.created)}
              </span>

              <span className={classes.dateText}>
                <UpdateIcon fontSize="small" />
                {formatDate(data.updated)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <CommonDialog
        open={openClone}
        title="Clone Scorecard Template"
        cancelText="Close"
        hideSubmitBtn
        onClose={() => setOpenClone(false)}
        content={
          <SingleInputForm
            getCloneIdeaTemplateFn={
              getCloneScorecardTemplateFn
            }
            myEmail={myEmail}
            currentTemplateIdPickUp={
              data.id
            }
            onSuccess={() =>
              setOpenClone(false)
            }
          />
        }
      />
    </>
  );
};

export default ScorecardCard;